function isObject(thing) {
  return thing != null;
}
export function isHttpError(err) {
  return isObject(err) && err.response != null;
}
export function responseDataHasMessage(data) {
  return isObject(data) && data.message != null;
}
export function responseDataHasDetails(data) {
  return isObject(data) && data.details != null;
}
//# sourceMappingURL=httpErrorDecoders.js.map